import { RegionData } from "types"

export const RegionTypeCell = ({ value }: { value: RegionData | null }) => {
    return <span>{value?.name ?? "-"}</span>
}
